export const LIBRARY_SUGGESTIONS = {
  np: [ // numpy
    "array", "zeros", "ones", "linspace", "arange", "dot", "sum", "mean", "std", "reshape", "transpose"
  ],
  numpy: [ // numpy
    "array", "zeros", "ones", "linspace", "arange", "dot", "sum", "mean", "std", "reshape", "transpose"
  ],
  pd: [ // pandas
    "DataFrame", "Series", "read_csv", "read_excel", "concat", "merge", "pivot_table", "isna", "fillna"
  ],
  pandas: [ // pandas
    "DataFrame", "Series", "read_csv", "read_excel", "concat", "merge", "pivot_table", "isna", "fillna"
  ],
  requests: [
    "get", "post", "put", "delete", "head", "options", "Session", "Request", "Response", "exceptions"
  ],
  yaml: [ // pyyaml
    "load", "safe_load", "dump", "safe_dump", "Loader", "SafeLoader", "Dumper", "SafeDumper"
  ],
  tqdm: [
    "tqdm", "trange", "auto", "gui", "notebook", "set_lock", "write"
  ],
  pytest: [
    "mark", "fixture", "raises", "parametrize", "skip", "skipif", "xfail", "hookimpl", "main"
  ],
  scipy: [
    "integrate", "optimize", "stats", "linalg", "signal", "fft", "interpolate", "sparse"
  ],
  sklearn: [
    "datasets", "metrics", "model_selection", "preprocessing", "linear_model", "tree", "ensemble", "neighbors"
  ],
  plt: [ // matplotlib.pyplot
    "plot", "scatter", "bar", "hist", "figure", "subplots", "xlabel", "ylabel", "title", "legend", "show"
  ],
  bs4: [ // beautifulsoup4
    "BeautifulSoup", "Comment", "NavigableString", "Tag", "element", "builder"
  ],
  lxml: [
    "etree", "html", "objectify", "cssselect", "parse", "tostring", "Element", "ElementTree"
  ],
  openpyxl: [
    "load_workbook", "Workbook", "utils", "styles", "worksheet", "cell", "writer"
  ],
  ng: [
    "DataHandler", "FileHandler", "Authenticator", "HttpCaller", "StatusHandler", "TaskHandler"
  ],
  dotenv: [ // python-dotenv
    "load_dotenv", "set_key", "get_key", "unset_key", "dotenv_values", "find_dotenv"
  ],
  plotly: [
    "graph_objects", "express", "figure_factory", "io", "subplots", "colors", "offline", "validators"
  ],
  pypdf: [
    "PdfReader", "PdfWriter", "PdfMerger", "PageObject", "PdfFileReader", "PdfFileWriter", "TextExtractionNotAllowed"
  ],
  docx: [ // python-docx
    "Document", "shared", "section", "paragraph", "table", "inline", "oxml", "sections"
  ]
};


export const SNIPPETS = {
  template: {
    content: `# %%
"""
NorthGravity Task Template (bare minimum)
- No sample data
- No stub functions (transform/validate/etc.)
- PROD/LOCAL switch
- main() called directly (no __name__ guard)
"""

# %%
### Imports ###
import os
import io
import sys
import logging
from datetime import datetime

import numpy as np
import pandas as pd
from dotenv import load_dotenv

import northgravity as ng

# %%
### Setup ###
load_dotenv()

logging.basicConfig(stream=sys.stdout, level=logging.INFO)
log = logging.getLogger(__name__)

ACTUAL_DATE = datetime.now()
MODE = os.getenv("MODE", "PROD")  # "PROD" or "LOCAL"

# NorthGravity handlers
dh = ng.DatalakeHandler()
th = ng.TaskHandler()
status = ng.StatusHandler()

# %%
def main() -> None:
    log.info("Starting task | MODE=%s", MODE)

    if MODE == "PROD":
        # Read inputs from NG Task parameters
        input_1_io = th.download_from_input_parameter(arg_name="Input #1", save=False)
        df_input_1 = pd.read_csv(input_1_io)

        input_2_io = th.download_from_input_parameter(arg_name="Input #2", save=False)
        df_input_2 = pd.read_csv(input_2_io)

    else:
        # LOCAL: read from files in the same folder as script
        script_dir = os.path.dirname(os.path.abspath(__file__))
        df_input_1 = pd.read_csv(os.path.join(script_dir, "input_1.csv"))
        df_input_2 = pd.read_csv(os.path.join(script_dir, "input_2.csv"))

    # ---------------------------------------------------------------------
    # PLACE FOR YOUR LOGIC (no stubs as requested)
    # Example expectation:
    # df_output_1, df_output_2, df_output_3 = ...
    # ---------------------------------------------------------------------
    df_output_1 = pd.DataFrame()
    df_output_2 = pd.DataFrame()
    df_output_3 = pd.DataFrame()

    if MODE == "PROD":
        # Upload outputs to NG Task parameters
        file_io = io.BytesIO(df_output_1.to_csv(index=False).encode())
        th.upload_to_output_parameter(
            output_name="Output #1",
            file=file_io,
            file_upload_name=f"OUTPUT_1_{ACTUAL_DATE:%Y-%m-%d_%H%M%S}.csv",
            group_name=os.environ.get("NG_STATUS_GROUP_NAME"),
            file_type="SOURCE",
            partial_update=True,
        )

        file_io = io.BytesIO(df_output_2.to_csv(index=False).encode())
        th.upload_to_output_parameter(
            output_name="Output #2",
            file=file_io,
            file_upload_name=f"OUTPUT_2_{ACTUAL_DATE:%Y-%m-%d_%H%M%S}.csv",
            group_name=os.environ.get("NG_STATUS_GROUP_NAME"),
            file_type="SOURCE",
            partial_update=True,
        )

        file_io = io.BytesIO(df_output_3.to_csv(index=False).encode())
        th.upload_to_output_parameter(
            output_name="Output #3",
            file=file_io,
            file_upload_name=f"OUTPUT_3_{ACTUAL_DATE:%Y-%m-%d_%H%M%S}.csv",
            group_name=os.environ.get("NG_STATUS_GROUP_NAME"),
            file_type="SOURCE",
            partial_update=True,
        )
    else:
        # LOCAL: write outputs next to script
        script_dir = os.path.dirname(os.path.abspath(__file__))
        df_output_1.to_csv(os.path.join(script_dir, "output_1.csv"), index=False)
        df_output_2.to_csv(os.path.join(script_dir, "output_2.csv"), index=False)
        df_output_3.to_csv(os.path.join(script_dir, "output_3.csv"), index=False)

    log.info("Done.")

# %%
main()`,
    name: 'NG template',
    tabTrigger: "template"
  },
  logging: {
    content:`
import os
import io
import pandas as pd
import logging
import sys

MODE = "PROD"

logging.basicConfig(stream=sys.stdout, level=os.environ.get("Logging Level").replace("\\"",""), force=True)
log = logging.getLogger(__name__)
if MODE == "PROD":
    import northgravity as ng
    # NorthGravity handlers
    dh = ng.DatalakeHandler()
    th = ng.TaskHandler()
    status = ng.StatusHandler()
`,
    name: "Initialize",
    tabTrigger: "log"
  },
  uploadFile: {
    content: `
out_file = "/tmp/result.csv"
out.to_csv(out_file, index=False)
th.upload_to_output_parameter(
    output_name="Output #1",
    file=out_file,
    file_upload_name=file_name,
    group_name=OUTPUT_GROUP,
    file_type="SOURCE",
    partial_update=True,
)`,
    name: "Upload file to csv",
    trigger: "upload"
  },
  uploadFile2: {
    content: `
def write_output_csv(df: pd.DataFrame,
                     output_name: str,
                     file_upload_name: str,
                     local_path: str | None = None) -> None:
    """
    output_name: e.g. "Output #1" (PROD)
    file_upload_name: e.g. "outage_summary_historical.csv"
    local_path: target file path (LOCAL)
    """
    csv_bytes = df.to_csv(index=False).encode()
    if MODE == "PROD":
        file_io = io.BytesIO(csv_bytes)
        th.upload_to_output_parameter(
            output_name=output_name,
            file=file_io,
            file_upload_name=file_upload_name,
            group_name=os.environ.get("NG_STATUS_GROUP_NAME"),
            file_type="SOURCE",
            partial_update=True
        )
    else:
        if not local_path:
            raise ValueError(f"In LOCAL you must provide local_path for {output_name}.")
        with open(local_path, "wb") as f:
            f.write(csv_bytes)

write_output_csv(
    df=df_example, 
    output_name="Output #1",
    file_upload_name="mapping_cleaned.csv",
    local_path="out/mapping_cleaned.csv"  # used only in LOCAL
)`,
    name: "Upload file",
    trigger: "upload"
  },
  downloadFile: {
    content: `
def read_input_csv(arg_name: str, local_path: str | None = None) -> pd.DataFrame:
  """
  arg_name: e.g. "Input #1" (PROD)
  local_path: CSV path for LOCAL testing
  """
  if MODE == "PROD":
      df_io = th.download_from_input_parameter(arg_name=arg_name)
      return pd.read_csv(df_io)
  else:
      if not local_path:
          raise ValueError(f"In LOCAL you must provide local_path for {arg_name}.")
      return pd.read_csv(local_path)
df_example = read_input_csv(arg_name="Input #1", local_path="data/mapping.csv")`,
    name: "Download file",
    trigger: "download"
  },
  readOutputGroup: {
    content: `OUTPUT_GROUP = os.environ.get("Output Group #1")`,
    name: "Read output group",
    trigger: "group"
  },
  basicStructure: {
    content: `
def main():
  # 1) INPUT
  df_in = read_input_csv(arg_name="Input #1", local_path="data/input.csv")

  # 2) PROCESSING (example)
  df_out = df_in.copy()  # replace with real logic

  # 3) OUTPUT
  write_output_csv(
      df=df_out,
      output_name="Output #1",
      file_upload_name="processed_output.csv",
      local_path="out/processed_output.csv"
  )

# Execute directly (no __name__ check)
if MODE == "PROD":
    try:
        log.info("Processing started…")
        main()
        log.info("Processing finished successfully.")
    except Exception as e:
        log.error(f"Error: {e}")
        raise
else:
    log.info("[LOCAL] Processing started…")
    main()
    log.info("[LOCAL] Processing finished.")`,
    name: "Basic code structure",
    trigger: "structure"
  },
  printDf: {
    content: `
def print_df(df, max_rows=10, max_cols=20):
  total_cols = len(df.columns)
  for start in range(0, total_cols, max_cols):
      end = start + max_cols
      cols = df.columns[start:end]
      print(f"\\n--- columns {start}:{end} ---")
      print(df.loc[:max_rows-1, cols].to_string(index=False))
`,
    trigger: "print",
    name: "Print data frame"
  }
}